import { graphql } from 'src/graphql';

export const SubmissionSessionFragment = graphql(`
  fragment SubmissionSessionFragment on Submission @_unmask {
    session {
      _id
      _session_id
      _online_task_link_id
      session {
        _id
        start
        end
        ResearcherUser {
          _id
          name
        }
      }
    }
  }
`);
